var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mt-3"},[_c('b-alert',{staticClass:"text-center pre-wrap",attrs:{"show":"","variant":_vm.levelChoices[_vm.publicMessageLevel]}},[_vm._v(" "+_vm._s(_vm.publicMessage)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }